import utils from 'utils'

class list_workspaceCtrl {
    constructor($scope, $filter, logger, httpRequest, $state, $rootScope, $stateParams) {
        $('body').addClass('leftnav-close')
        // 查询展开
        $scope.isFilterCollapsed = false
        $scope.workState = true// 工作台状态，已办还是待办的标志
        $scope.resData = []// list数据
        $scope.workflowList = []
        $scope.totalItems = 0 // 组件初始化设置总页数
        $scope.currentPage = 1 // 设置显示第一页
        $scope.maxSize = 10 // 每一叶显示记录数
        $rootScope.leftNavDisabled = true
        // 消息中心传过来的的主键
        const _bussinessKey = $stateParams.bussinessKey
        console.log(_bussinessKey)

        $scope.profileType = '73'

        const aMonth = utils.genPeriodByMonth()
        $scope.param = {
            pageNum: $scope.currentPage,
            pageSize: $scope.maxSize,
            param: {
                applyCode: '',
                applyUser: '',
                approveCode: $stateParams.approveCode || '',
                beginCompleteTime: aMonth.start,
                endCompleteTime: aMonth.end,
            },
        }
        $scope.reset = function () {
            $scope.param.param = {
                applyCode: '',
                applyUser: '',
                approveCode: $stateParams.approveCode || '',
                beginCompleteTime: aMonth.start,
                endCompleteTime: aMonth.end,
            }
        }
        // $scope.reset()
        // 字典数据
        $scope.dictData = {}
        const typecodeArrStr = '["invoice_source", "notice_type_a", "inv_type","bill_status","is_list","invoice_nature","tax_includ","is_privilege","wait_invoice_status","is_pass","yes_no_flag","red_info_applicant"]'
        httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
        })

        // 类型选择框
        $scope.TypeList = [{
            enumCode: '',
            enumName: '全部',
        }, {
            enumCode: 'bill_approve',
            enumName: '销售单审核',
        }, {
            enumCode: 'opened_invoice_approve',
            enumName: '开票申请单审核',
        }, {
            enumCode: 'red_info_approve',
            enumName: '红字信息表审核',
        },
        {
            enumCode: 'cancel_invoice_approve',
            enumName: '发票作废审核',
        },
        {
            enumCode: 'reopen_invoice_approve',
            enumName: '发票重开审核',
        },
        {
            enumCode: 'sb_approve',
            enumName: '增值税申报表审核',
        },
        {
            enumCode: 'ivat_expense_approve',
            enumName: '报销单审批',
        },
        ]
        $scope.$on('$stateChangeStart', () => {
            sessionStorage.removeItem('workspaceParam1')
            sessionStorage.removeItem('workspaceParam0')
        })
        // 选项卡
        $scope.tabChange = function (typeFlag) {
            // $scope.param.pageNum = 1
            $scope.reset()
            if (typeFlag) { // 我的待办
                $scope.param = sessionStorage.workspaceParam1 ? JSON.parse(sessionStorage.workspaceParam1) : $scope.param
                $scope.workState = true
                $scope.profileType = '73'
                qry_listData(typeFlag)
            } else { // 我的已办
                $scope.param = sessionStorage.workspaceParam0 ? JSON.parse(sessionStorage.workspaceParam0) : $scope.param
                $scope.workState = false
                $scope.profileType = '74'
                qry_listData(typeFlag)
            }
        }

        // 按钮滑过
        $scope.dropdown_rowhover = function (row, flag) {
            row.dropdownhover = flag
        }

        // 状态按钮滑过
        $scope.dropdown_rowhover_state = function (row, flag) {
            row.dropdowstatenhover = flag
        }
        // 表格行划过
        $scope.tb_rowhover = function (row, flag) {
            row.mouseenter = flag
        }
        // 按钮滑过
        $scope.dropdown_rowhover = function (row, flag) {
            row.dropdownhover = flag
        }

        // 全选状态
        $scope.tb_isAllselected = false

        // 表格全选
        $scope.tb_selectAll = function (val) {
            $scope.tb_isAllselected = val
            for (const a in $scope.resData) {
                $scope.resData[a].selected = $scope.tb_isAllselected
            }
        }
        // 表格单选
        $scope.tb_rowSelect = function () {
            // 全选
            let len = 0
            for (const a in $scope.resData) {
                if ($scope.resData[a].selected == true) len++
            }
            if (len == $scope.resData.length) {
                $scope.tb_isAllselected = true
            } else {
                $scope.tb_isAllselected = false
            }
        }

        // 分页器
        $scope.pageChanged = function () {
            if ($scope.workState) { // 我的待办
                sessionStorage.setItem('workspaceParam1', JSON.stringify(
                    {
                        pageNum: $scope.currentPage,
                        pageSize: $scope.maxSize,
                        param: sessionStorage.workspaceParam1 ? JSON.parse(sessionStorage.workspaceParam1).param : {
                            applyCode: '',
                            applyUser: '',
                            approveCode: $stateParams.approveCode || '',
                            beginCompleteTime: aMonth.start,
                            endCompleteTime: aMonth.end,
                        },
                    },
                ))
            } else { // 我的已办
                sessionStorage.setItem('workspaceParam0', JSON.stringify(
                    {
                        pageNum: $scope.currentPage,
                        pageSize: $scope.maxSize,
                        param: sessionStorage.workspaceParam0 ? JSON.parse(sessionStorage.workspaceParam0).param : {
                            applyCode: '',
                            applyUser: '',
                            approveCode: $stateParams.approveCode || '',
                            beginCompleteTime: aMonth.start,
                            endCompleteTime: aMonth.end,
                        },
                    },
                ))
            }
            qry_listData($scope.workState)
        }
        // 搜索
        $scope.searchlist = function () {
            // sessionStorage.setItem(stroageStr, JSON.stringify($scope.param))
            if (!$scope.workState) {
                sessionStorage.setItem('workspaceParam0', JSON.stringify($scope.param))
            } else {
                sessionStorage.setItem('workspaceParam1', JSON.stringify($scope.param))
            }
            qry_listData($scope.workState)
        }
        // 审核通过
        $scope.pass = function (item) {
            const taskList = []
            taskList.push(item)
            $scope.submitTaskList(taskList, 1)
        }

        /** *
         * 任务提交阻塞执行任务提交
         */
        $scope.submitTaskList = function (taskList, isPass, reason) {
            const task = taskList[0]
            // 执行任务
            httpRequest.post_submitTask({
                reason,
                isPass,
                taskId: task.actionId,
            }).then((res) => {
                logger.logSuccess(`审核任务[${task.actionId}]成功`)
                if (taskList.length > 1) {
                    $scope.submitTaskList(taskList.slice(1), isPass, reason)
                } else {
                    qry_listData(true)
                }
            }, (err) => {
                logger.logError(`审核任务[${task.actionId}]失败:${err.data.message}`)
                if (taskList.length > 1) {
                    $scope.submitTaskList(taskList.slice(1), isPass, reason)
                } else {
                    qry_listData(true)
                }
            })
        }
        // 审核不通过
        $scope.notpass = function (item) {
            const taskList = []
            taskList.push(item)
            $scope.submitTaskModal(taskList)
        }
        /** **
         * 审核弹框设置
         */
        $scope.submitTaskModal = function (taskList) {
            logger.logMsg({
                title: '审核',
                icon: 'tishi',
                btn: ['确定', '取消'],
                message: '<p>确定审核不通过吗？<br>您可以写下不通过原因，帮助申请者改正!</p><textarea class="form-control" style="resize: none;font-size: 13px;"></textarea>',
                yes(index) {
                    const reason = $('.layui-layer-content textarea').val()
                    if (reason && reason.length > 100) {
                        logger.logError('提交失败审核原因不能超过100字符')
                        return
                    }
                    $scope.submitTaskList(taskList, 0, reason)
                    layer.close(index) // 如果设定了yes回调，需进行手工关闭
                },
            })
        }
        // 批量审核通过
        $scope.passAll = function () {
            const taskList = $filter('filter')($scope.resData, { selected: true })
            if (taskList.length == 0) {
                logger.logError('还未选择数据')
                return
            }
            $scope.submitTaskList(taskList, 1)
        }
        // 批量审核不通过
        $scope.notpassAll = function () {
            const taskList = $filter('filter')($scope.resData, { selected: true })
            if (taskList.length == 0) {
                logger.logError('还未选择数据')
                return
            }
            $scope.submitTaskModal(taskList)
        }
        // 详情
        $scope.toDetailPage = function (val) {
            if (val === undefined) {
                logger.logError('参数错误，请刷新重试')
            } else {
                // $('body').removeClass('leftnav-close')
                // $rootScope.leftNavDisabled = false
                // $state.go('workspace.item', { taskId: utils.encode(JSON.stringify(val)) })
                const currentSearchOtions = {
                    applyCode: $scope.param.param.applyCode,
                    applyUser: $scope.param.param.applyUser,
                    approveCode: $scope.param.param.approveCode,
                    taskType: $scope.workState ? 0 : 1,
                    destination: '',
                }
                val.currentSearchOtions = currentSearchOtions
                const url = $state.href('workspace.item', { taskId: utils.encode(JSON.stringify(val)) }, { reload: true })
                window.open(url, '_blank')
            }
        }

        // 请求参数
        function qry_listData(type) {
            const days = utils.DateMinus($scope.param.param.beginCompleteTime, $scope.param.param.endCompleteTime)
            if (days > 31) {
                logger.logError('申请日期查询跨度不允许超过一个月')
                return
            }
            // $scope.param.pageSize = $scope.maxSize
            // $scope.param.pageNum = $scope.currentPage
            if (!type) {
                $scope.param = sessionStorage.workspaceParam0 ? JSON.parse(sessionStorage.workspaceParam0) : $scope.param
                httpRequest.post_getHisTaskDTOList($scope.param).then((res) => {
                    $scope.resData = res.data.value.list
                    $scope.totalItems = res.data.value.total //
                    $scope.currentPage = ++res.data.value.prePage
                    $scope.maxSize = res.data.value.pageSize
                    $scope.param.pageNum = res.data.value.pageNum
                })
            } else {
                $scope.param = sessionStorage.workspaceParam1 ? JSON.parse(sessionStorage.workspaceParam1) : $scope.param
                httpRequest.post_getRunTaskDTOList($scope.param).then((res) => {
                    $scope.resData = res.data.value.list
                    $scope.totalItems = res.data.value.total //
                    $scope.currentPage = ++res.data.value.prePage
                    $scope.maxSize = res.data.value.pageSize
                    $scope.param.pageNum = res.data.value.pageNum
                })
            }
        }
    }
}
list_workspaceCtrl.$inject = ['$scope', '$filter', 'logger', 'httpRequest', '$state', '$rootScope', '$stateParams']
export default list_workspaceCtrl



// WEBPACK FOOTER //
// ./src/app/main/workspace/list_workspaceCtrl.js